<template>
    <DADataTable
        ref="store_products_ref"
        :tableData="tableData"
        :tableOptions="tableOptions"
    />
</template>


<script scoped>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/store";

    import { ajax } from "@/_common";

    import DADataTable from "@/components/table/DADataTable";

    export default {
        name: 'ProductsQuantity',
        components: {
            DADataTable,
        },
        props:{
            data:{
                type: Object
            }
        },
        setup(props) {
            const store = useStore();

            const TR = ref({});

            const tableData = ref([]);
            const tableOptions = ref({});

            const store_products_ref = ref(); //selectedProducts


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: false,
                    // row_total_field: ["total"],
                    // row_per_page: 5,

                    data_table_columns: [
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: 'image',
                            title: TR.value.image,
                            value: (e) => `<img src="${
                                    e.employee && e.employee.image
                                        ? e.employee.image
                                        : "/assets/img/noimg.png"
                                }" title="${TR.value.user}" class="border rounded-circle img-circle-cover" />`,
                            exportable: false,
                            sortable: false,
                            filter: false,
                        },
                        {
                            name: 'store.translate.0.name',
                            title: TR.value.store,
                            value: (e) => e.store.translate[0].name,
                            sortable: false,
                            filter: false,
                        },
                        {
                            name: 'area.name',
                            title: TR.value.area,
                            value: (e) => e.area.name,
                            sortable: false,
                            filter: false,
                        },
                        {
                            name: 'quantity',
                            title: TR.value.quantity,
                            value: 'quantity',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "gte" }],
                            },
                            data_type: 'numeric',
                            filter_mode: 'integer',
                        },
                    ],
                };
            });


            onMounted(async () => {
                await ajax({
                    url: store.getStoreProductsQuantityLink(props.data.data.id),
                    success: (e) => {
                        if (e.status == 200 && e.data) {
                            // const res = e.data;
                            tableData.value = e.data; //.filter(x => x.create_date !== null);
                            // tableData.value.forEach(x => x.create_date = new Date(moment(x.create_date, 'DD.MM.YYYY hh:mm:ss')));
                            // tableData.value.forEach(x => x.create_date = new Date(x.create_date));
                        }
                    }
                });
            });


            return {
                TR,
                tableData,
                tableOptions,
                store_products_ref,
            };
        },
    };
</script>

